import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { extendedApiIppica } from 'features/api/ippicaApiSlice';
import { IppicaNazioneDto } from 'types/swagger';

export type FavoriteNazione = Omit<IppicaNazioneDto, 'titolo'>;

export type IppicaFavouriteNazioniState = {
  favouriteNazioni: Record<string, IppicaNazioneDto>;
};

const initialState: IppicaFavouriteNazioniState = {
  favouriteNazioni: {},
};

const ippicaFavouriteNazioniSlice = createSlice({
  name: 'ippicaFavouriteNazioni',
  initialState,
  reducers: {
    addNationToFavorite: (state, { payload }: PayloadAction<IppicaNazioneDto>) => {
      const { titolo, image, ippodromi } = payload;
      if (titolo) {
        state.favouriteNazioni[titolo] = { titolo, image, ippodromi };
      }
    },
    removeNationFromFavorite: (state, { payload }: PayloadAction<string>) => {
      if (state.favouriteNazioni[payload]) {
        delete state.favouriteNazioni[payload];
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(extendedApiIppica.endpoints.getIppicaMenu.matchFulfilled, (state, action) => {
      const menuData = action.payload;
      Object.keys(state.favouriteNazioni).forEach((nazioneKey) => {
        const { ippodromi } = (menuData ?? []).find((nazione) => nazione.titolo === nazioneKey) ?? {};
        state.favouriteNazioni[nazioneKey].ippodromi = ippodromi ?? [];
      });
    });
  },
});

export const { addNationToFavorite, removeNationFromFavorite } = ippicaFavouriteNazioniSlice.actions;
export default ippicaFavouriteNazioniSlice.reducer;
